// extracted by mini-css-extract-plugin
export default {"container":"cookbook_container__I7Hex","row":"cookbook_row__gi7vu"};